<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-subheader pl-2>
						Recurso padre: {{ resourceName }}
					</v-subheader>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12>
						<role-access-subresource-list
							:check-all="checkAll"
							:columns="columns"
							:rows="table.rows"
							:last-page="table.lastPage"
							@all-is-selected="allIsSelected"
							@change-page="changePage"
							@on-search="onSearch($event, 'resources-permission')"
							@row-is-selected="rowIsSelected"
						/>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import roleAccessSubresourceList from './role-access-subresource-list';

async function created() {
	this.params.flagLevels = this.flagLevels;
	this.params.modulesId = this.modulesId;
	this.params.resourceId = this.resourceId;
	this.loadData('resources-permission');
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', false, checked);
	this.setDataSelected();
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData('resources-permission');
}

function closeModal() {
	this.$emit('close-modal');
}

function rowIsSelected(row) {
	this.table.rows = this.selectIsRow(this.table.rows, 'isSelected', row);
	this.checkAll = this.every(this.table.rows);
	this.setDataSelected(row);
}

function setDataSelected(row) {
	if (!row) {
		if (this.checkAll) {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.findIndex(d => d.id === rowData.id);
				if (index < 0) {
					this.dataSelected.push(rowData);
				}
			});
		} else {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.findIndex(d => d.id === rowData.id);
				if (index >= 0) {
					this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		const index = this.dataSelected.findIndex(d => d.id === row.id);
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}

function submitForm() {
	this.closeModal();
	const model = {
		subresources: this.table.rows,
		resourceId: this.resourceId,
	};
	this.$emit('send-selection', model);
}

function data() {
	return {
		checkAll: false,
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
		],
		currentPage: 1,
		dataSelected: [],
		flagLevels: 1,
	};
}

export default {
	name: 'role-access-subresource-form',
	components: {
		roleAccessSubresourceList,
	},
	created,
	data,
	methods: {
		allIsSelected,
		changePage,
		closeModal,
		rowIsSelected,
		setDataSelected,
		submitForm,
	},
	props: {
		loading: {
			default: false,
			type: Boolean,
		},
		modulesId: {
			type: String,
		},
		resourceId: {
			type: [Number, String],
		},
		resourceName: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-access-subresource-form.vue